import { createContext, useContext } from 'react';

import { Event } from 'utils/types';

interface CONTEXT {
  data?: Event[];
  filters: Record<string, any>;
  tabs: string[];
}

const CalendarContext = createContext<CONTEXT | null>(null);

export const useCalendarContext = () => useContext(CalendarContext);

export default CalendarContext;
